<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('settings.pingen_settings.form.client_id')"
            :is-required="true"
            :error="errorsData.appErrors?.client_id"
            :hint="__('settings.pingen_settings.form.client_id_hint')"
        >
            <DInput
                id="client_id"
                v-model="form.client_id"
                :placeholder="__('settings.pingen_settings.form.client_id')"
                :is-valid="isFormFieldValid('client_id')"
                type="text"
                @update:value="disableSubmit"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.pingen_settings.form.client_secret')"
            :is-required="true"
            :error="errorsData.appErrors?.client_secret"
            :hint="__('settings.pingen_settings.form.client_secret_hint')"
        >
            <DInput
                id="client_secret"
                v-model="form.client_secret"
                :placeholder="__('settings.pingen_settings.form.client_secret')"
                :is-valid="isFormFieldValid('client_secret')"
                type="text"
                @update:value="disableSubmit"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.pingen_settings.form.organisation_id')"
            :is-required="true"
            :error="errorsData.appErrors?.organisation_id"
            :hint="__('settings.pingen_settings.form.organisation_id_hint')"
        >
            <DInput
                id="organisation_id"
                v-model="form.organisation_id"
                :placeholder="__('settings.pingen_settings.form.organisation_id')"
                :is-valid="isFormFieldValid('organisation_id')"
                type="text"
                @update:value="disableSubmit"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.pingen_settings.form.env')"
            :is-required="true"
            :error="errorsData.appErrors?.env"
            :hint="__('settings.pingen_settings.form.env_hint')"
        >
            <DSelect
                id="env"
                v-model="form.env"
                :options="env"
                :is-valid="isFormFieldValid('env')"
                @update:value="disableSubmit"
            />
        </DFormRow>
        <DRow>
            <DCol sm="4" />
            <DCol sm="4">
                <div
                    v-show="connectionStatus === 'successful'"
                    class="green-text"
                >
                    {{ __('settings.connections.connection_successful') }}
                </div>
                <div
                    v-show="connectionStatus === 'unsuccessful'"
                    class="red-text"
                >
                    {{ __('settings.connections.connection_unsuccessful') }}
                </div>
            </DCol>
            <DCol
                sm="4"
                class="check-database-connection-btn"
            >
                <DButton
                    icon="lan-connect"
                    :label="__('settings.connections.check_connection')"
                    :disabled="isInLoadingState"
                    @click="checkConnection"
                />
            </DCol>
        </DRow>
        <DFormControls
            :dirty="form.isDirty"
            :disabled="connectionStatus !== 'successful'"
            @submit="submitForm"
        />
    </DForm>
    <CheckConnectionErrorModal
        :show="showErrorModal"
        is-error
        is-medium
        :api-error="errorsData.apiError"
        :validation-errors="errorsData.appErrors"
        :back-trace="errorsData.backTrace"
        :title="__('settings.pingen_settings.error_modal.title')"
        :message="__('settings.pingen_settings.error_modal.message')"
        @close="clearData"
    />
</template>

<script>

import CheckConnectionErrorModal from '~@/Components/Settings/CheckConnectionErrorModal'

export default {
    name: 'PingenSettingsForm',
    components: { CheckConnectionErrorModal },
    props: {
        pingenSettings: {
            type: Object,
            default: () => { return {} }
        },
        env: {
            type: Array,
            default: () => { return [] }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['form-submitted'],
    data () {
        return {
            form: this.$inertia.form({
                client_id: this.pingenSettings?.client_id ?? null,
                client_secret: this.pingenSettings?.client_secret ?? null,
                organisation_id: this.pingenSettings?.organisation_id ?? null,
                env: this.pingenSettings?.env ?? null,
                postal_delivery: 'pingen'
            }),
            errorsData: {
                apiError: null,
                appErrors: this.errors,
                backTrace: null
            },
            showErrorModal: false,
            connectionStatus: null
        }
    },
    methods: {
        submitForm () {
            this.$emit('form-submitted', this.form)
        },
        checkConnection () {
            this.errorsData.appErrors = null
            const self = this
            window.axios.post(this.$route('settings.postal-delivery-settings.check-pingen'), this.form)
                .then(function () {
                    self.connectionStatus = 'successful'
                })
                .catch(function (error) {
                    self.connectionStatus = 'unsuccessful'
                    self.showErrorModal = true
                    if (error.response.data.errors !== undefined) {
                        self.errorsData.appErrors = error.response.data.errors

                        for (const key in self.errorsData.appErrors) {
                            if (typeof self.errorsData.appErrors[key] === 'object') {
                                self.errorsData.appErrors[key] = self.errorsData.appErrors[key][0]
                            }
                        }
                    }

                    if (error.response.data.api_error !== undefined) {
                        self.errorsData.apiError = error.response.data.api_error
                        self.errorsData.backTrace = error.response.data.back_trace
                    }
                })
        },
        disableSubmit () {
            this.connectionStatus = null
        },
        clearData () {
            this.showErrorModal = false
            this.errorsData.apiError = null
            this.errorsData.backTrace = null
        }
    }
}
</script>

<style lang="scss" scoped>
.check-database-connection-btn {
    text-align: right;
    padding-bottom: 25px;
}
.green-text {
    color: green;
}
.red-text {
    color: red;
}
</style>
